<script>
import { defineAsyncComponent } from "vue";
import {Head, Link, router, useForm} from '@inertiajs/vue3';
import CheckOrXMark from "@/Components/Icons/CheckOrXMark.vue";
import Pagination from "@/Components/Pagination.vue";

export default {
    components: {
        Pagination,
        CheckOrXMark,
        BreezeAuthenticatedLayout: defineAsyncComponent(() => import('@/Layouts/Authenticated.vue')),
        BreezeButton: defineAsyncComponent(() => import('@/Components/Button.vue')),
        Head,
        useForm,
        Link,
    },
    props: {
        clients: Object,
        search: String,
    },
    data() {
        return {
            searchData: this.search,
            timerId: null,
        }
    },

    watch: {
        searchData: function (value) {
                this.updateQueryString(value);

                clearTimeout(this.timerId);

                this.timerId = setTimeout(() => {
                    router.reload({ only: ['clients'] });
                }, 1000);
        }
    },

    methods: {
        resetInput() {
            this.search = "";
        },

        updateQueryString(searchValue) {
            const currentUrl = new URL(window.location);
            currentUrl.searchParams.set('search', searchValue);
            // everytime search is updated, we reset the page to 1
            currentUrl.searchParams.set('page', 1);
            window.history.pushState({}, '', currentUrl);
        }
    },
}
</script>
<template>
    <Head title="My Clients" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="justify-between flex">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight flex">
                    Clients
                </h2>

                <Link :href="route('clients.create')" class="btn">
                    <span>Add</span>
                    <span class="hidden md:inline">&nbsp;Client</span>
                </Link>
            </div>

        </template>

        <div class="py-12">

            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 pb-4">
                <div class="block relative">
                    <input
                        type="text"
                        v-model="searchData"
                        class="py-4 px-5 w-full focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm border-gray-300 rounded-md"
                        placeholder="Search client..."
                        autofocus
                        />
                        <svg @click="resetInput" class="h-4 w-4 text-slate-300 absolute right-5 top-5 rounded-full cursor-pointer"  width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg>
                </div>
            </div>

            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">

                        <table class="w-full whitespace-nowrap table-auto">
                            <caption class="hidden">Client list</caption>
                            <thead>
                                <tr class="text-left font-bold">
                                    <th class="pb-4 pt-6 px-6" scope="col">Id</th>
                                    <th class="pb-4 pt-6 px-6" scope="col">Name</th>
                                    <th class="pb-4 pt-6 px-6" scope="col">Brand Slug</th>
                                    <th class="pb-4 pt-6 px-6" scope="col">Password grant</th>
                                    <th class="pb-4 pt-6 px-6" scope="col">Not Revoked</th>
                                    <th class="pb-4 pt-6 px-6" scope="col">Created</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="client in clients.data" :key="client.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                                <td class="border-t py-2">
                                    <Link class="flex items-center px-6" :href="route('clients.edit', {client: client.id})" tabindex="-1">
                                        {{ client.id }}
                                    </Link>
                                </td>
                                <td class="border-t py-2">
                                    <Link class="flex items-center px-6" :href="route('clients.edit', {client: client.id})" tabindex="-1">
                                        {{ client.name }}
                                    </Link>
                                </td>
                                <td class="border-t py-2">
                                    <Link class="flex items-center px-6" :href="route('clients.edit', {client: client.id})" tabindex="-1">
                                        {{ client.brand_slug }}
                                    </Link>
                                </td>
                                <td class="border-t py-2">
                                    <Link class="flex items-center px-6" :href="route('clients.edit', {client: client.id})" tabindex="-1">
                                        <CheckOrXMark :condition="((client.password_client === 1))" />
                                    </Link>
                                </td>
                                <td class="border-t py-2">
                                    <Link class="flex items-center px-6" :href="route('clients.edit', {client: client.id})" tabindex="-1">
                                        <CheckOrXMark :condition="(!(client.revoked === 1))" />
                                    </Link>
                                </td>
                                <td class="w-px border-t py-2">
                                    {{ formatDate(client.created_at) }}
                                </td>
                            </tr>
                            <tr v-if="clients.length === 0">
                                <td class="px-6 py-4 border-t" colspan="4">No Clients found.</td>
                            </tr>
                            </tbody>
                        </table>

                        <pagination class="mt-6" :links="clients.links" />

                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>


